<template>
  <div>
    <hsm-header></hsm-header>
    <container-nav>
      <template slot-scope="p">
        <Nav :list="p.list" :styles="p.styles" sticky></Nav>
      </template>
    </container-nav>
    <UC :menus="menus"></UC>
    <hsm-footer></hsm-footer>
  </div>
</template>

<script>
  import containerNav from '@/containers/nav/containerNav'
  import Nav from '@/components/hsm/nav/index'
  import hsmHeader from '@/pages/others/header'
  import hsmFooter from '@/pages/others/footer'
  import UC from '@/page/modules/uc/index'
  export default {
    components: { UC, containerNav, Nav, hsmHeader, hsmFooter },
    data () {
      return {
        menus: [{
          id: '0122',
          name: '我的课程',
          path: '/uc/record',
          iconClass: 'icon_a'
        }, {
          id: '0123',
          name: '我的收藏',
          path: '/uc/fav',
          iconClass: 'icon_b'
        }, /* {
          id: '0124',
          name: '我的考试',
          path: '/uc/examination',
          iconClass: 'icon_c'
        }, */{
          id: '0126',
          name: '我的证书',
          path: '/uc/lrecord',
          iconClass: 'icon_d'
        }, {
          id: '0130',
          name: '我的订单',
          path: '/uc/order',
          iconClass: 'icon_h'
        }, {
          id: '0129',
          name: '我的开票',
          path: '/uc/invoice',
          iconClass: 'icon_h'
        }, {
          id: '0127',
          name: '我的消息',
          path: '/uc/message',
          iconClass: 'icon_e'
        }, {
          id: '0128',
          name: '资料设置',
          path: '/uc/set',
          iconClass: 'icon_f'
        }]
      }
    }
  }
</script>

<style scoped>
  .member_top { margin-top: 0px; }
</style>



// WEBPACK FOOTER //
// src/pages/uc/pageIndex.vue